// import axios from 'axios';
// import { createBrowserHistory } from 'history';
// import { toast } from 'react-toastify';
// const history = createBrowserHistory();

// //  let apiRoot =process.env.REACT_APP_API_KEY_DEV;
// // let apiRoot ='https://www.mizuwatch.com/';
// // let apiRoot ='https://mizusmart.com/';
//   // let apiRoot ='https://www.mizuwatch.com/';
// //  let apiRoot = "http://192.168.48.103:5000/";
// // let apiRoot = 'http://192.168.96.111:5000/';
// // let apiRoot ='http://192.168.96.110:5000';
// const apiRoot = import.meta.env.VITE_API_URL;
// var data = JSON.parse(localStorage.getItem("MCData"));

// const config = {
//   headers: {
//     'Content-Type': 'application/json',
//     // "Authorization":`Bearer ${data?.token}`,
//    }
// };

// const axiosInstance = axios.create({
//   baseURL: apiRoot,
// });

// const requestHandler = (request) => {
//   request.headers['Platform'] = 'Web';

//   if (localStorage.MCData) {
//     const { token, refreshToken } = JSON.parse(localStorage.MCData);
//     // if (token) { request.headers.Authorization = 'Bearer ' + token; }
//     if (token) { request.headers['Authorization'] = 'Bearer ' + token;
//     request.headers['District'] = '1';
//   }
//     if (refreshToken) { request.headers.refreshToken = refreshToken; }
//   }
//   return request;
// };

// let responseFailed = (error) => {
//   if (error && error.response && error.response.data && error.response.data.message === 'ReLogin') {
//     localStorage.clear();
//     console.log(history);
//     //window.location.reload();
//     history.pushState({}, '', '/Login');
//     window.location.href = '#logout';

//     return Promise.reject({ ...error });
//   }
//   if (
//     error.request &&
//     error.request.status &&
//     (error.request.status === '400' || error.request.status === '404')
//   ) {
//     return Promise.reject({ ...error });
//   }

//   return Promise.reject({ ...error });
// };

// const responseSuccess = (response) => {
//   if (localStorage.MCData) {
//     var MCData = JSON.parse(localStorage.MCData);
//     const { token, refreshtoken } = response.headers;
//     if (token != null && refreshtoken !== null) {
//       if (token !== MCData.token && refreshtoken !== MCData.refreshToken) {
//         MCData.token = token;
//         MCData.refreshToken = refreshtoken;
//         localStorage.removeItem('MCData');
//         localStorage.setItem('MCData', JSON.stringify(MCData));
//       }
//     }
//   }
//   return response;
// };

// function errorHandler(error) {
//   if (error) {
//     let { response } = error;
//     let { data } = response || {};
//     // console.log(error.message);
//     if (error && error.isAxiosError && !response) {
//       toast.error('Network Issue or Server Down', {
//         autoClose: 3000,
//         toastId: 'network',
//       });
//     }
//     // else if (response && response.status == 401) {
//     //   toast.error(data.message.message, {
//     //     autoClose: 3000,
//     //     toastId: 'network',
//     //   });
//     // }
//     else if (response && response.status == 401) {
//       toast.error("Token has expired please login", {
//         autoClose: 3000,
//         toastId: 'network',
//       });
//     }
//     else if (data && data.statusCode && data.statusCode == 400 && data.message && data.message.message) {
//       toast.error(response.data.message.message.join('\n'), {
//         autoClose: 3000,
//         toastId: 'network',
//       });
//     } else if (data && data.statusCode && data.statusCode == 400 && data.message) {
//       toast.error(response.data.message.message, {
//         autoClose: 3000,
//         toastId: 'network',
//       });
//     } else {
//       // toast.error(JSON.stringify(data), {
//       //   autoClose: 3000,
//       //   toastId: 'network',
//       // });
//     }
//   }
// }

// class httpService {
//   constructor() {
//     if (axiosInstance.interceptors.request.handlers.length === 0) {
//       axiosInstance.interceptors.request.use((request) =>
//         requestHandler(request)
//       );

//       axiosInstance.interceptors.response.use(
//         (response) => responseSuccess(response),
//         (error) => responseFailed(error)
//       );
//     }
//   }

//   getWithHeader(path, header) {
//     if (path) {
//       return axiosInstance.get(apiRoot + path, header, config);
//     }
//   }

//   async get(path, model) {
//     return new Promise((resolve, reject) => {
//       if (path) {
//         // debugger;
//         try {
//           return axiosInstance.get(
//             apiRoot +
//             path
//             //  +
//             // (path.includes('?') ? '&date=' : '?date=')
//             // +
//             // new Date()
//             ,
//             model,
//             config
//           )
//             .then((result) => {
//               resolve(result);
//             })
//             .catch((error) => {
//               errorHandler(error);
//               reject(error);
//             });
//         }
//         catch (error) {
//           reject(error);
//         }
//       }
//     });
//   }

//   post(path, model) {
//     return new Promise((resolve, reject) => {
//       if (path) {
//         try {
//           return axiosInstance
//             .post(apiRoot + path, model, config)
//             .then((result) => {
//               resolve(result);
//             })
//             .catch((error) => {
//               errorHandler(error);
//               reject(error);
//             });
//         } catch (error) {
//           reject(error);
//         }
//       }
//     });
//   }
//   put(path, model) {
//     return new Promise((resolve, reject) => {
//       if (path) {
//         try {
//           return axiosInstance.put(apiRoot + path, model, config)
//             .then((result) => {
//               resolve(result);
//             })
//             .catch((error) => {
//               errorHandler(error);
//               reject(error);
//             });
//         } catch (error) {
//           reject(error);
//         }
//       }
//     });
//   }
//   patch(path, model) {
//     return new Promise((resolve, reject) => {
//       if (path) {
//         try {
//           return axiosInstance.patch(apiRoot + path, model, config)
//             .then((result) => {
//               resolve(result);
//             })
//             .catch((error) => {
//               errorHandler(error);
//               reject(error);
//             });
//         } catch (error) {
//           reject(error);
//         }
//       }
//     });
//   }
//   remove(path, model) {
//     return new Promise((resolve, reject) => {
//       if (path) {
//         try {
//           return axiosInstance.delete(apiRoot + path, { data: model }, config)
//             .then((result) => {
//               resolve(result);
//             })
//             .catch((error) => {
//               errorHandler(error);
//               reject(error);
//             });
//         } catch (error) {
//           reject(error);
//         }
//       }
//     });
//   }
// }

// export const http = new httpService();
// export const getWithHeader = new httpService().getWithHeader;
// export const get = new httpService().get;
// export const post = new httpService().post;
// export const put = new httpService().put;
// export const patch = new httpService().patch;
// export const remove = new httpService().remove;
// export const apiUrl = apiRoot;

// HttpService.js

import axios from "axios";
import { createBrowserHistory } from "history";
import { toast } from "react-toastify";

const history = createBrowserHistory();
const apiRoot = import.meta.env.VITE_API_URL;

const axiosInstance = axios.create({
  baseURL: apiRoot,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🧩 Request Interceptor
axiosInstance.interceptors.request.use((request) => {
  request.headers["Platform"] = "Web";

  const storedData = localStorage.getItem("MCData");
  if (storedData) {
    const { token, refreshToken, selectedDistrict } = JSON.parse(storedData);
    if (token) {
      request.headers["Authorization"] = `Bearer ${token}`;
      request.headers["District"] = selectedDistrict;
    }
    if (refreshToken) {
      request.headers.refreshToken = refreshToken;
    }
  }

  return request;
});

// 🧩 Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const storedData = localStorage.getItem("MCData");
    const { token, refreshtoken } = response.headers;

    if (storedData && token && refreshtoken) {
      const MCData = JSON.parse(storedData);
      if (token !== MCData.token || refreshtoken !== MCData.refreshToken) {
        localStorage.setItem(
          "MCData",
          JSON.stringify({
            ...MCData,
            token,
            refreshToken: refreshtoken,
          })
        );
      }
    }

    return response;
  },
  (error) => {
    if (error?.response?.data?.message === "ReLogin") {
      localStorage.clear();
      history.pushState({}, "", "/login");
      window.location.href = "#logout";
    }

    return Promise.reject(error);
  }
);

// 🛑 Error Handler
const errorHandler = (error) => {
  const { response } = error || {};
  const { data } = response || {};

  if (axios.isCancel(error)) {
    console.log("Request canceled:", error.message);
    return; // 👈 prevent toast from showing
  }

  // if (error?.isAxiosError && !response) {
  //   toast.error("Network Issue or Server Down", {
  //     autoClose: 3000,
  //     toastId: "network",
  //   });
  // } else 
    if (response?.status === 401) {
    localStorage.clear();
    toast.error("Token has expired please login", {
      autoClose: 3000,
      toastId: "network",
    });
    history.push("/login");
    window.location.reload();
  } else if (data?.statusCode === 400 && data?.message?.message) {
    const message = Array.isArray(data.message.message)
      ? data.message.message.join("\n")
      : data.message.message;
    toast.error(message, {
      autoClose: 3000,
      toastId: "network",
    });
  }
};

// 📦 HTTP Methods

const getWithHeader = (path, header) =>
  axiosInstance.get(apiRoot + path, header);

const get = async (path, model) => {
  try {
    const response = await axiosInstance.get(apiRoot + path, model);
    return response;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

// const post = async (path, model) => {
//   try {
//     const response = await axiosInstance.post(apiRoot + path, model);
//     return response;
//   } catch (error) {
//     errorHandler(error);
//     throw error;
//   }
// };
const post = async (path, model) => {
  try {
    // ✅ Detect FormData
    const isFormData = model instanceof FormData;

    const response = await axiosInstance.post(apiRoot + path, model, {
      headers: isFormData
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" },
    });

    return response;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

const put = async (path, model) => {
  try {
    const response = await axiosInstance.put(apiRoot + path, model);
    return response;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

const patch = async (path, model) => {
  try {
    const response = await axiosInstance.patch(apiRoot + path, model);
    return response;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

const remove = async (path, model) => {
  try {
    const response = await axiosInstance.delete(apiRoot + path, {
      data: model,
    });
    return response;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

// ✅ DO NOT CHANGE EXPORTS
export const http = {
  getWithHeader,
  get,
  post,
  put,
  patch,
  remove,
};

export { getWithHeader, get, post, put, patch, remove, apiRoot as apiUrl };
